import { render, staticRenderFns } from "./TabelaEscolherModelo.vue?vue&type=template&id=7e8ae1ce"
import script from "./TabelaEscolherModelo.vue?vue&type=script&lang=js"
export * from "./TabelaEscolherModelo.vue?vue&type=script&lang=js"
import style0 from "./TabelaEscolherModelo.vue?vue&type=style&index=0&id=7e8ae1ce&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports